
import Vue from 'vue'

/**
 * The component is a first attempt to solve the problem of flags.
 * + it is always the same image, only the background position changes;
 * - we need to keep a pretty complex country mapping, that gets ruined whenever something changes;
 * - scales terribly.
 */

type FlagGridMapping = {
  [key: string]: [number, number]
}

const flagGridMapping: FlagGridMapping = {
  // x, y
  AU: [4, 6],
  AT: [6, 1],
  BE: [8, 1],
  BG: [10, 1],
  BR: [12, 1],
  CA: [13, 1],
  CH: [16, 1],
  CY: [5, 2],
  CZ: [6, 2],
  DE: [7, 2],
  DK: [9, 2],
  EE: [12, 2],
  ES: [14, 2],
  FI: [16, 2],
  FR: [1, 3],
  GB: [3, 3],
  GR: [7, 3],
  HK: [10, 3],
  HU: [13, 3],
  IE: [15, 3],
  IL: [16, 3],
  IN: [1, 4],
  IT: [5, 4],
  JP: [9, 4],
  LI: [2, 5],
  LT: [4, 5],
  LU: [5, 5],
  LV: [6, 5],
  MT: [12, 5],
  MX: [13, 5],
  MY: [14, 5],
  NL: [2, 6],
  NO: [3, 6],
  NZ: [4, 6],
  PL: [11, 6],
  PT: [14, 6],
  RO: [1, 7],
  RU: [2, 7],
  SE: [5, 7],
  SG: [6, 7],
  SI: [7, 7],
  SK: [8, 7],
  US: [4, 8],
  ZA: [10, 8],
}

export default Vue.extend({
  name: 'R-Flag',
  props: {
    of: { type: String },
  },
  computed: {
    style() {
      const margin = 31 - 21
      const height = 15
      const width = 21
      const [x, y] = flagGridMapping[this.of]
      const horizontalOffset = (x - 1) * (width + margin) + margin
      const verticalOffset = (y - 1) * (height + margin) + margin

      return {
        position: 'relative',
        backgroundImage: `url(${require('@/assets/img/flagIcons.svg')})`,
        backgroundPosition: `-${horizontalOffset}px -${verticalOffset}px`,
        backgroundOrigin: 'center',
        backgroundRepeat: 'no-repeat',
        height: '15px',
        width: '21px',
        display: 'inline-block',
        marginRight: '12px',
        borderRadius: '1.6px',
      }
    },
  },
})
